var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('div', {
    staticClass: "res-dropdown"
  }, [_vm.printRead ? [_c('span', {
    staticClass: "res-print-read m-l-5"
  })] : [_vm.dropdownType === 'text' ? [_c('el-dropdown', _vm._g(_vm._b({}, 'el-dropdown', _vm.$attrs, false), _vm.$listeners), [_c('span', {
    staticClass: "el-dropdown-link",
    attrs: {
      "disabled": !_vm.edit || _vm.disabled
    }
  }, [_vm._t("default", function () {
    return [_vm._v(" " + _vm._s(_vm.buttonName)), _c('i', {
      staticClass: "el-icon-arrow-down el-icon--right"
    })];
  })], 2), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.options, function (item) {
    return _c('el-dropdown-item', {
      key: item[_vm.valueKey],
      attrs: {
        "command": item[_vm.valueKey],
        "icon": item[_vm.iconKey],
        "disabled": !_vm.edit || item.disabled,
        "divided": item.divided
      }
    }, [_vm._v(" " + _vm._s(item[_vm.labelKey]) + " ")]);
  }), 1)], 1)] : _vm.dropdownType === 'button' ? [_c('el-dropdown', [_c('el-button', _vm._b({
    attrs: {
      "disabled": !_vm.edit || _vm.disabled
    }
  }, 'el-button', _vm.$attrs, false), [_vm._t("default", function () {
    return [_vm._v(" " + _vm._s(_vm.buttonName)), _c('i', {
      staticClass: "el-icon-arrow-down el-icon--right"
    })];
  })], 2), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.options, function (item) {
    return _c('el-dropdown-item', {
      key: item[_vm.valueKey],
      attrs: {
        "command": item[_vm.valueKey],
        "icon": item[_vm.iconKey],
        "disabled": !_vm.edit || item.disabled,
        "divided": item.divided
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 1)] : [_c('el-dropdown', _vm._g(_vm._b({
    attrs: {
      "split-button": ""
    }
  }, 'el-dropdown', _vm.$attrs, false), _vm.$listeners), [_vm._t("default", function () {
    return [_vm._v(_vm._s(_vm.buttonName))];
  }), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, _vm._l(_vm.options, function (item) {
    return _c('el-dropdown-item', {
      key: item[_vm.valueKey],
      attrs: {
        "command": item[_vm.valueKey],
        "icon": item[_vm.iconKey],
        "disabled": !_vm.edit || item.disabled,
        "divided": item.divided
      }
    }, [_vm._v(" " + _vm._s(item.label) + " ")]);
  }), 1)], 2)]], _vm.description ? _c('div', {
    staticClass: "cmp-desc"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()], 2);
};

var staticRenderFns = [];
export { render, staticRenderFns };